var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "separation-of-funds" },
    [
      _vm.isDeliveredForObligation
        ? _c("proposal-PO-info", {
            attrs: { details: _vm.proposalRequestInfo }
          })
        : _vm._e(),
      _c("section-title", {
        staticClass: "mt-4 mb-3",
        attrs: {
          "has-line": "",
          title: "Asignación de Fondos",
          "title-class": "section-title-info"
        }
      }),
      _vm.tabModes.viewMode === _vm.state
        ? _c(
            "div",
            _vm._l(_vm.separationFunds, function(separationFund, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("separation-fund-row", {
                    key: separationFund.separationFundNumber,
                    attrs: {
                      "is-contract-signed": _vm.isContractSigned,
                      "proposal-request-id":
                        _vm.proposalRequestId ??
                        separationFund.proposalRequestId,
                      "proposal-status-id":
                        _vm.proposalRequestInfo?.proposalRequestStatus?.id,
                      value: separationFund
                    },
                    on: { "on-edit": _vm.handleEdit }
                  })
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm.tabModes.addingState != _vm.state &&
      _vm.tabModes.editMode != _vm.state &&
      _vm.separationFunds.length > 0 &&
      _vm.canAddSeparationFunds
        ? _c(
            "div",
            { staticClass: "row justify-content-end p-3" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-file-plus",
                  text: " Añadir",
                  variant: "success"
                },
                on: {
                  click: function($event) {
                    return _vm.changeState(_vm.tabModes.addingState)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.tabModes.addingState === _vm.state
        ? _c(
            "div",
            { staticClass: "px-3 py-2" },
            [
              _c(
                "validation-observer",
                { ref: "separationOfFunds" },
                [
                  _c("div", { staticClass: "row mx-auto" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-3 p-0 mr-md-4" },
                      [
                        _c("div", { staticClass: "label mb-2" }, [
                          _vm._v("Contratación:")
                        ]),
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        id: `reason`,
                                        "custom-error-msg":
                                          "La contratación es requerida.",
                                        disabled: true,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.contractTypes,
                                        placeholder: "Seleccione"
                                      },
                                      model: {
                                        value: _vm.record.contractType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.record,
                                            "contractType",
                                            $$v
                                          )
                                        },
                                        expression: "record.contractType"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            467651937
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-2" },
                      [
                        _c("div", { staticClass: "label mb-2" }, [
                          _vm._v("Fecha de Separación:")
                        ]),
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-date-picker", {
                                      staticClass: "col-12 p-0",
                                      attrs: {
                                        "custom-error-msg":
                                          "La fecha de separación es requerida.",
                                        error: errors[0],
                                        placeholder: "DD/MM/YYYY"
                                      },
                                      model: {
                                        value: _vm.record.date,
                                        callback: function($$v) {
                                          _vm.$set(_vm.record, "date", $$v)
                                        },
                                        expression: "record.date"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3373615009
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-2" },
                      [
                        _c("div", { staticClass: "label mb-2" }, [
                          _vm._v("Fecha Hasta:")
                        ]),
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-date-picker", {
                                      staticClass: "col-12 p-0",
                                      attrs: {
                                        clearable: false,
                                        "custom-error-msg":
                                          "La fecha hasta es requerida.",
                                        error: errors[0],
                                        "max-date": _vm.academicYear.toDate,
                                        "min-date": _vm.academicYear.fromDate,
                                        placeholder: "DD/MM/YYYY"
                                      },
                                      model: {
                                        value: _vm.record.contractDateTo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.record,
                                            "contractDateTo",
                                            $$v
                                          )
                                        },
                                        expression: "record.contractDateTo"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            673778158
                          )
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mx-auto" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 p-0 mr-md-4" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-text-area", {
                                      staticClass: "col-12 p-0",
                                      attrs: {
                                        "custom-error-msg":
                                          "La justificación es requerida.",
                                        error: errors[0],
                                        label: "Nombre de justificación:",
                                        maxlength: 3000,
                                        placeholder:
                                          "Escriba una Justificación",
                                        "show-char-count": ""
                                      },
                                      model: {
                                        value: _vm.record.justification,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.record,
                                            "justification",
                                            $$v
                                          )
                                        },
                                        expression: "record.justification"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1346932923
                          )
                        })
                      ],
                      1
                    )
                  ]),
                  _c("section-title", {
                    staticClass: "mt-4 mb-3",
                    attrs: {
                      "has-line": "",
                      title: "Cifra de Cuentas",
                      "title-class": "section-title-info"
                    }
                  }),
                  _vm.addingCifras
                    ? _c(
                        "div",
                        { staticClass: "px-3" },
                        [
                          _vm._l(_vm.accountNumbersSelected, function(
                            accountNumber
                          ) {
                            return _c("account-number", {
                              key: `accountNumber-${accountNumber.purchaseOrderNumberId}`,
                              staticClass: "mb-3",
                              attrs: {
                                "billing-service-categories":
                                  _vm.billingServiceCategories,
                                "is-read-only": true,
                                value: accountNumber
                              },
                              on: { remove: _vm.removeAccountNumber }
                            })
                          }),
                          _vm.addingAccountNumbersMore
                            ? _c("account-number", {
                                staticClass: "mb-4",
                                attrs: {
                                  "account-numbers":
                                    _vm.accountNumbersUnSelected,
                                  "billing-service-categories":
                                    _vm.billingServiceCategories,
                                  "can-remove":
                                    _vm.accountNumbersSelected.length > 0,
                                  "date-from": null,
                                  "date-to": _vm.record.contractDateTo,
                                  required:
                                    _vm.accountNumbersSelected.length == 0
                                },
                                on: {
                                  add: _vm.addAccountNumber,
                                  cancel: _vm.cancelAddingAccountNumber
                                }
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  !_vm.addingCifras ||
                  (!_vm.addingAccountNumbersMore &&
                    _vm.accountNumbersSelected.length > 0 &&
                    _vm.accountNumbersUnSelected.length > 0)
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-content-end" },
                        [
                          _vm.separationFunds.length > 0
                            ? _c("action-button", {
                                attrs: {
                                  i: "fa fa-times-circle",
                                  text: "Cancelar",
                                  variant: "outline-danger mr-3"
                                },
                                on: { click: _vm.handleCancel }
                              })
                            : _vm._e(),
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-file-plus",
                              text: "Añadir Cifra de Cuentas",
                              variant: "success"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showAddingCifras()
                              }
                            }
                          }),
                          _vm.ownSave && _vm.accountNumbersSelected.length > 0
                            ? _c("action-button", {
                                attrs: {
                                  i: "fas fa-save",
                                  text: "Guardar",
                                  variant: "success ml-3"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.saveHandler()
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.tabModes.editMode === _vm.state && _vm.currentEditFund
        ? _c(
            "div",
            { staticClass: "px-3 py-2" },
            [
              _c(
                "validation-observer",
                { ref: "separationOfFunds" },
                [
                  _c("div", { staticClass: "row mx-auto" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-3 p-0 mr-md-4" },
                      [
                        _c("div", { staticClass: "label mb-2" }, [
                          _vm._v("Contratación:")
                        ]),
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        id: `reason`,
                                        "custom-error-msg":
                                          "La contratación es requerida.",
                                        disabled: true,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.contractTypes,
                                        placeholder: "Seleccione"
                                      },
                                      model: {
                                        value: _vm.currentEditFund.contractType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.currentEditFund,
                                            "contractType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "currentEditFund.contractType"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2618826528
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-2" },
                      [
                        _c("div", { staticClass: "label mb-2" }, [
                          _vm._v("Fecha de Separación:")
                        ]),
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-date-picker", {
                                      staticClass: "col-12 p-0",
                                      attrs: {
                                        "custom-error-msg":
                                          "La fecha de separación es requerida.",
                                        error: errors[0],
                                        placeholder: "DD/MM/YYYY"
                                      },
                                      model: {
                                        value: _vm.currentEditFund.date,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.currentEditFund,
                                            "date",
                                            $$v
                                          )
                                        },
                                        expression: "currentEditFund.date"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            180265472
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-2" },
                      [
                        _c("div", { staticClass: "label mb-2" }, [
                          _vm._v("Fecha Hasta:")
                        ]),
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-date-picker", {
                                      staticClass: "col-12 p-0",
                                      attrs: {
                                        clearable: false,
                                        "custom-error-msg":
                                          "La fecha hasta es requerida.",
                                        error: errors[0],
                                        "max-date": _vm.academicYear.toDate,
                                        "min-date": _vm.academicYear.fromDate,
                                        placeholder: "DD/MM/YYYY"
                                      },
                                      model: {
                                        value:
                                          _vm.currentEditFund.contractDateTo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.currentEditFund,
                                            "contractDateTo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "currentEditFund.contractDateTo"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            641069903
                          )
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mx-auto" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 p-0 mr-md-4" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-text-area", {
                                      staticClass: "col-12 p-0",
                                      attrs: {
                                        "custom-error-msg":
                                          "La justificación es requerida.",
                                        error: errors[0],
                                        label: "Nombre de justificación:",
                                        maxlength: 3000,
                                        placeholder:
                                          "Escriba una Justificación",
                                        "show-char-count": ""
                                      },
                                      model: {
                                        value:
                                          _vm.currentEditFund.justification,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.currentEditFund,
                                            "justification",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "currentEditFund.justification"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2201955962
                          )
                        })
                      ],
                      1
                    )
                  ]),
                  _c("section-title", {
                    staticClass: "mt-4 mb-3",
                    attrs: {
                      "has-line": "",
                      title: "Cifra de Cuentas",
                      "title-class": "section-title-info"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "px-3" },
                    [
                      _vm._l(_vm.currentEditFund.accountNumbers, function(
                        accountNumber
                      ) {
                        return _c("account-number", {
                          key: `accountNumber-${accountNumber.purchaseOrderNumberId}`,
                          staticClass: "mb-3",
                          attrs: {
                            "billing-service-categories":
                              _vm.billingServiceCategories,
                            "is-read-only": true,
                            value: accountNumber
                          },
                          on: { remove: _vm.removeAccountNumber }
                        })
                      }),
                      _vm.addingAccountNumbersMore
                        ? _c("account-number", {
                            staticClass: "mb-4",
                            attrs: {
                              "account-numbers": _vm.accountNumbersUnSelected,
                              "billing-service-categories":
                                _vm.billingServiceCategories,
                              "can-remove":
                                _vm.accountNumbersSelected.length > 0,
                              "date-from": null,
                              "date-to": _vm.currentEditFund.contractDateTo,
                              required: _vm.accountNumbersSelected.length == 0
                            },
                            on: {
                              add: _vm.addAccountNumber,
                              cancel: _vm.cancelAddingAccountNumber
                            }
                          })
                        : _vm._e()
                    ],
                    2
                  ),
                  !_vm.addingCifras ||
                  (!_vm.addingAccountNumbersMore &&
                    _vm.accountNumbersSelected.length > 0 &&
                    _vm.accountNumbersUnSelected.length > 0)
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-content-end" },
                        [
                          _vm.separationFunds.length > 0
                            ? _c("action-button", {
                                attrs: {
                                  i: "fa fa-times-circle",
                                  text: "Cancelar",
                                  variant: "outline-danger mr-3"
                                },
                                on: { click: _vm.handleCancel }
                              })
                            : _vm._e(),
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-file-plus",
                              text: "Añadir Cifra de Cuentas",
                              variant: "success"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showAddingCifras(true)
                              }
                            }
                          }),
                          _vm.ownSave && _vm.accountNumbersSelected.length > 0
                            ? _c("action-button", {
                                attrs: {
                                  i: "fas fa-save",
                                  text: "Guardar",
                                  variant: "success ml-3"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.saveHandler()
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }